import { Button, IconButton, IconProps, Tooltip } from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

export function NavLink({
  children,
  to,
  icon: Icon,
  isActive,
  onClick,
  isCollapsed,
}: {
  children: string;
  to: string;
  icon: React.ComponentType<IconProps>;
  isActive: boolean;
  onClick?: () => void;
  isCollapsed: boolean;
}) {
  const label = children;

  if (isCollapsed) {
    return (
      <Tooltip label={label} placement="right" hasArrow>
        <IconButton
          as={RouterLink}
          to={to}
          onClick={onClick}
          aria-label={label}
          colorScheme="gray"
          variant="ghost"
          size="md"
          icon={
            <Icon
              color={isActive ? "primary.500" : undefined}
              boxSize="1.5rem"
            />
          }
          bg={isActive ? "gray.700" : undefined}
        />
      </Tooltip>
    );
  }

  return (
    <Button
      as={RouterLink}
      to={to}
      onClick={onClick}
      colorScheme="gray"
      variant="ghost"
      w="full"
      justifyContent="flex-start"
      leftIcon={
        <Icon color={isActive ? "primary.500" : undefined} boxSize="1.5rem" />
      }
      bg={isActive ? "gray.700" : undefined}
    >
      {children}
    </Button>
  );
}
